// Purchase Order-related filters

import {
	createDateRangeFilter,
	createKeywordFilter,
	createStatusFilter,
} from './factories';
import type { FilterRegistry } from './types';

export const purchaseOrderFilters: FilterRegistry = {
	purchaseOrderKeywords: {
		...createKeywordFilter({
			label: 'Search',
			placeholder: 'Search by PO number, vendor, or description...',
			objectTable: 'purchase_order',
			listKeys: ['purchase_order', 'purchase-order-vendor-embedded'],
			fulltextFields: ['externalId', 'externalId2', 'description', 'notes'],
		}),
		queryParamName: 'purchaseOrderKeywords',
	},

	purchaseOrderStatus: {
		...createStatusFilter({
			label: 'Status',
			options: [
				{ id: '0', label: 'New' },
				{ id: '1', label: 'Pending Approval' },
				{ id: '2', label: 'Approved' },
				{ id: '3', label: 'Released' },
				{ id: '4', label: 'Partially Received' },
				{ id: '5', label: 'Received' },
				{ id: '6', label: 'Held' },
				{ id: '7', label: 'Cancelled' },
				{ id: '8', label: 'Backordered' },
				{ id: '9', label: 'Rejected' },
				{ id: '10', label: 'Quote' },
			],
			objectTable: 'purchase_order',
			fieldName: 'status',
			listKeys: ['purchase_order', 'purchase-order-vendor-embedded'],
		}),
		queryParamName: 'purchaseOrderStatus',
	},

	purchaseOrderExpirationDateRange: {
		...createDateRangeFilter({
			label: 'Expiration Date',
			objectTable: 'purchase_order',
			fieldName: 'expirationDate',
			listKeys: ['purchase_order'],
		}),
		queryParamName: 'purchaseOrderExpirationDateRange',
	},

	purchaseOrderFollowUpDateRange: {
		...createDateRangeFilter({
			label: 'Follow-Up Date',
			objectTable: 'purchase_order',
			fieldName: 'followUpDate',
			listKeys: ['purchase_order'],
		}),
		queryParamName: 'purchaseOrderFollowUpDateRange',
	},

	// Approval-gate state. Drives the "Pending Approval" PO list
	// tab (filter to `submitted`) and any future per-state views.
	// Distinct from `purchaseOrderStatus` — this tracks whether the
	// PO has been routed through the threshold-driven approval gate,
	// orthogonal to the lifecycle status (QUOTE / APPROVED / etc.).
	purchaseOrderApprovalStatus: {
		...createStatusFilter({
			label: 'Approval Status',
			options: [
				{ id: 'submitted', label: 'Submitted for Approval' },
				{ id: 'approved', label: 'Approved' },
				{ id: 'rejected', label: 'Rejected' },
			],
			objectTable: 'purchase_order',
			fieldName: 'approvalStatus',
			listKeys: ['purchase_order'],
		}),
		queryParamName: 'purchaseOrderApprovalStatus',
	},
};
